export interface Activity {
    id: number;
    name: string;
}

export function ActivityFromJSON(json: any): Activity {
    return {
        id: json["id"],
        name: json["name"],
    }
}
